<template>
  <div>
    <v-toolbar
      height="60"
      color="teal darken-1"
      app
      center
      class="baner"
    >
      <v-btn
        color="green"
        class="white--text"
        href="/inicio"
      >
        INICIO
        <v-icon
          right
          dark
        >
          home
        </v-icon>
      </v-btn>
      <v-spacer />
      <h2 class="center white--text">
        UNIVERSIDAD NACIONAL INTERCULTURAL DE QUILLABAMBA
      </h2>
      <v-spacer />
    </v-toolbar>
    <br>
    <div class="titulo">
      <h2>Formatos</h2>
    </div>
    <v-layout
      row
      wrap
    >
      <v-spacer />
      <v-flex
        xs12
        sm12
      >
        <v-card>
          <!-- //{{{ -->
          <v-list-tile href="https://admisionapi.uniq.edu.pe/public/storage/formato01.pdf">
            <v-list-tile-action>
              <v-icon color="red">
                file_download
              </v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              Formato 01 - Compromiso deporte
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile href="https://admisionapi.uniq.edu.pe/public/storage/formato02.pdf">
            <v-list-tile-action>
              <v-icon color="red">
                file_download
              </v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              Formato 02 - Pertenencia a comunidad
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile href="https://admisionapi.uniq.edu.pe/public/storage/formato03.pdf">
            <v-list-tile-action>
              <v-icon color="red">
                file_download
              </v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              Formato 03 - Compromiso laboral
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile href="https://admisionapi.uniq.edu.pe/public/storage/formato04.pdf">
            <v-list-tile-action>
              <v-icon color="red">
                file_download
              </v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              Formato 04 - Compromiso vestimenta
            </v-list-tile-content>
          </v-list-tile>
        </v-card> <!-- //}}} -->
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
export default {
  data () {
    return {
      card_text: 'En esta modalidad pueden postular:'
    }
  }
}
</script>
<style>
.extraordinario {
  background-color: white;
  color: #ff5722;
}
.ordinario {
  background-color: white;
  color: green;
}
.titulo {
  margin-top: 10px;
  margin-block: 10px;
  text-align: center;
  align-items: center;
  align-content: center;
  padding-right: 1.4rem;
  font-size: 25px;
  color: #00695c;
}
.center {
  display: flex;
  align-items: center;
  padding-right: 1.4rem;
  font-size: 25px;
  margin-inline-start: 20px;
}
.card-modality {
  height: 280px;
}
.card-title {
  height: 125px;
}
@media only screen and (max-width: 600px) {
  .center {
    display: flex;
    align-items: center;
    padding-right: 0.5em;
    font-size: 10px;
    margin-inline-start: 20px;
  }
}
</style>
